import type { RecruitingSiteResponse } from '@flex-apis/recruiting';
import type { PublishedRecruitingSiteResponse } from '@flex-private-packages/recruiting-site-builder/base';
import { isPublishedSite } from '@flex-private-packages/recruiting-site-builder/base';

import { ErrorSubdomain } from '../../constants';

import { ErrorPage } from './errors';

export function assertPublishedSite(
  response: RecruitingSiteResponse
): asserts response is PublishedRecruitingSiteResponse {
  if (!isPublishedSite(response)) {
    throw createSiteUnpublishedError();
  }
}

export function createSiteUnpublishedError(): ErrorPage {
  return new ErrorPage(
    '미발행된 사이트입니다.',
    ErrorSubdomain.SiteUnpublishedSubdomain
  );
}
